import { isBedbankOffer, isLEHotel } from 'lib/offer/offerTypes'
import { getLocationDataFromOffer } from './getLocationDataFromOffer'
import { getLocationHeadingTextFromAccommodationView } from './tripRequestUtils'
import { buildItemPolicyLookup } from './buildItemPolicyEvaluationItem'
import { resolveCartLineTravellers, type CartLineContext } from './resolveCartLineTravellers'
import type { CartEvaluationItemInputWire } from 'businessTraveller/api/requestPostCartEvaluation'

// Hotel + bedbank: one line per room, both map to a HOTEL item policy
export function buildAccommodationCartEvaluationItems(
  accommodationOfferViews: App.WithDataStatus<Array<App.Checkout.AccommodationOfferView>>,
  context: CartLineContext,
): Array<CartEvaluationItemInputWire> {
  if (!accommodationOfferViews.hasRequiredData) {
    return []
  }

  const items: Array<CartEvaluationItemInputWire> = []

  for (const offerView of accommodationOfferViews.data) {
    const offer = offerView.offer
    if (!offer || (!isLEHotel(offer) && !isBedbankOffer(offer))) {
      continue
    }

    const { location } = getLocationDataFromOffer(offer)
    const numberOfNights = offerView.duration

    // The current hotel stay.
    const hotel = {
      location: getLocationHeadingTextFromAccommodationView(offerView),
      checkIn: offerView.startDate as string,
      checkOut: offerView.endDate as string,
    }

    for (const itemView of offerView.itemViews) {
      const cost = (itemView.totals.price ?? 0) + (itemView.totals.surcharge ?? 0)
      if (!cost || !numberOfNights) {
        continue
      }

      items.push({
        transactionKey: itemView.item.transactionKey,
        cost,
        travellers: resolveCartLineTravellers(context, itemView.item.occupancy),
        itemPolicyLookup: buildItemPolicyLookup({
          itemPolicyType: 'HOTEL',
          cacheKey: itemView.item.transactionKey,
          currencyCode: context.currencyCode,
          employeeIds: [],
          numberOfNights,
          roomCount: 1,
          latitude: location?.latitude,
          longitude: location?.longitude,
        }),
        details: { hotel },
      })
    }
  }

  return items
}
